//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class Colors
{
	public static smgViolet: string = `#9105BF`;
	public static smgPink: string = `#fb115c`;
	public static smgGreen: string = `#31bb11`;
	public static smgGray: string = `#3c3c3c`;
	public static defaultRouteColor: string = `#9105BF`;
}
